export type Lang = "tr" | "en";

export const translations = {
  tr: {
    appName: "Lumicle Şarj Ağı",
    appSubtitle: "Türkiye geneli şarj istasyonları",
    search: "İstasyon, şehir, adres ara…",
    filters: "Filtreler",
    powerType: "Güç tipi",
    minPower: "Min. güç",
    status: "Durum",
    reset: "Sıfırla",
    apply: "Uygula",
    all: "Tümü",
    ac: "AC",
    dc: "DC",
    location: "Lokasyon",
    locations: "lokasyon",
    socket: "soket",
    sockets: "soket",
    operator: "Operatör",
    address: "Adres",
    facilities: "Olanaklar",
    tariffs: "Tarifeler",
    perKwh: "/kWh",
    vatIncluded: "KDV dahil",
    showOnMap: "Haritada göster",
    backToList: "Listeye dön",
    noResults: "Sonuç bulunamadı",
    loading: "Yükleniyor…",
    errorTitle: "Veri alınamadı",
    errorRetry: "Tekrar dene",
    poweredBy: "OCPI 2.2 üzerinden canlı veri",
    maxPower: "Maks. güç",
    connectors: "Konnektörler",
    distance: "mesafe",
    km: "km",
    legend: "Lejant",
    fast: "Hızlı",
    ultraFast: "Ultra Hızlı",
    nearMe: "Yakınımdaki",
    stopLocate: "Konumu kapat",
    locating: "Konum alınıyor…",
    geoDenied: "Konum izni reddedildi",
    geoUnavailable: "Konum servisi mevcut değil",
    sortNearest: "En yakın",
    sortDefault: "Varsayılan",
    dcUltraPreset: "DC Ultra ≥150 kW",
    directions: "Yol tarifi al",
    copyAddress: "Adresi kopyala",
    copied: "Kopyalandı",
    youAreHere: "Buradasınız",
    statCities: "Şehir",
    statLocations: "Lokasyon",
    statAcSockets: "AC Soket",
    statDcSockets: "DC Soket",
    statSubtitle: "Lumicle Şarj Ağı",
    statUpdated: "Güncellendi",
    statusAVAILABLE: "Müsait",
    statusCHARGING: "Doluyor",
    statusOUTOFORDER: "Arızalı",
    statusRESERVED: "Rezerve",
    statusINOPERATIVE: "Devre dışı",
    statusPLANNED: "Planlı",
    statusREMOVED: "Kaldırıldı",
    statusBLOCKED: "Engelli",
    statusUNKNOWN: "Bilinmiyor",
    facilityHOTEL: "Otel",
    facilityRESTAURANT: "Restoran",
    facilityCAFE: "Kafe",
    facilitySUPERMARKET: "Market",
    facilitySPORT: "Spor",
    facilityRECREATION_AREA: "Dinlenme",
    facilityNATURE: "Doğa",
    facilityMUSEUM: "Müze",
    facilityBIKE_SHARING: "Bisiklet",
    facilityBUS_STOP: "Otobüs",
    facilityTAXI_STAND: "Taksi",
    facilityTRAIN_STATION: "Tren",
    facilityAIRPORT: "Havalimanı",
    facilityPARKING_LOT: "Otopark",
    facilityCARPOOL_PARKING: "Carpool",
    facilityFUEL_STATION: "Akaryakıt",
    facilityWIFI: "Wi-Fi",
  },
  en: {
    appName: "Lumicle Charging Network",
    appSubtitle: "Charging stations across Türkiye",
    search: "Search station, city, address…",
    filters: "Filters",
    powerType: "Power type",
    minPower: "Min. power",
    status: "Status",
    reset: "Reset",
    apply: "Apply",
    all: "All",
    ac: "AC",
    dc: "DC",
    location: "Location",
    locations: "locations",
    socket: "socket",
    sockets: "sockets",
    operator: "Operator",
    address: "Address",
    facilities: "Facilities",
    tariffs: "Tariffs",
    perKwh: "/kWh",
    vatIncluded: "VAT included",
    showOnMap: "Show on map",
    backToList: "Back to list",
    noResults: "No results",
    loading: "Loading…",
    errorTitle: "Couldn't fetch data",
    errorRetry: "Retry",
    poweredBy: "Live data via OCPI 2.2",
    maxPower: "Max power",
    connectors: "Connectors",
    distance: "distance",
    km: "km",
    legend: "Legend",
    fast: "Fast",
    ultraFast: "Ultra Fast",
    nearMe: "Near me",
    stopLocate: "Turn off location",
    locating: "Getting location…",
    geoDenied: "Location permission denied",
    geoUnavailable: "Location service unavailable",
    sortNearest: "Nearest",
    sortDefault: "Default",
    dcUltraPreset: "DC Ultra ≥150 kW",
    directions: "Get directions",
    copyAddress: "Copy address",
    copied: "Copied",
    youAreHere: "You are here",
    statCities: "Cities",
    statLocations: "Locations",
    statAcSockets: "AC Sockets",
    statDcSockets: "DC Sockets",
    statSubtitle: "Lumicle Charging Network",
    statUpdated: "Updated",
    statusAVAILABLE: "Available",
    statusCHARGING: "Charging",
    statusOUTOFORDER: "Out of order",
    statusRESERVED: "Reserved",
    statusINOPERATIVE: "Inoperative",
    statusPLANNED: "Planned",
    statusREMOVED: "Removed",
    statusBLOCKED: "Blocked",
    statusUNKNOWN: "Unknown",
    facilityHOTEL: "Hotel",
    facilityRESTAURANT: "Restaurant",
    facilityCAFE: "Cafe",
    facilitySUPERMARKET: "Supermarket",
    facilitySPORT: "Sport",
    facilityRECREATION_AREA: "Recreation",
    facilityNATURE: "Nature",
    facilityMUSEUM: "Museum",
    facilityBIKE_SHARING: "Bike sharing",
    facilityBUS_STOP: "Bus stop",
    facilityTAXI_STAND: "Taxi stand",
    facilityTRAIN_STATION: "Train",
    facilityAIRPORT: "Airport",
    facilityPARKING_LOT: "Parking",
    facilityCARPOOL_PARKING: "Carpool",
    facilityFUEL_STATION: "Fuel",
    facilityWIFI: "Wi-Fi",
  },
} as const;

export type TKey = keyof (typeof translations)["tr"];
